export const API_PROVIDER_COMMENTS_TABLE = 'API_PROVIDER_COMMENTS_TABLE';
export const API_PROVIDER_COMMENTS_LIST = 'API_PROVIDER_COMMENTS_LIST';
export const API_PROVIDER_COMMENTS_UPSERT = 'API_PROVIDER_COMMENTS_UPSERT';
export const API_PROVIDER_COMMENTS_GET = 'API_PROVIDER_COMMENTS_GET';
export const API_PROVIDER_COMMENTS_DELETE = 'API_PROVIDER_COMMENTS_DELETE';
export const API_PROVIDER_COMMENTS_DOCUMENTS_TABLE = 'API_PROVIDER_COMMENTS_DOCUMENTS_TABLE';
export const API_PROVIDER_COMMENTS_PROVIDERS_TABLE = 'API_PROVIDER_COMMENTS_PROVIDERS_TABLE';
export const API_PROVIDER_COMMENTS_CONTACTS_TABLE = 'API_PROVIDER_COMMENTS_CONTACTS_TABLE';
export const API_PROVIDER_COMMENTS_LOCATIONS_TABLE = 'API_PROVIDER_COMMENTS_LOCATIONS_TABLE';

export const queryProviderComments = (options, type = API_PROVIDER_COMMENTS_TABLE) => ({
  type,
  request: {
    url: '/ProviderComments',
    method: 'GET',
    params: { opts: options },
  },
});

export const queryProviderCommentsDocuments = (options, type = API_PROVIDER_COMMENTS_DOCUMENTS_TABLE) => ({
  type,
  request: {
    // endpoint that returns an array like
      // [{ id: <providerCommentId>, documents: [...] }, ... ]
      url: '/ProviderComments',
    method: 'GET',
    params: { opts: options },
  },
});

export const queryProviderCommentsProviders = (options, type = API_PROVIDER_COMMENTS_PROVIDERS_TABLE) => ({
  type,
  request: {
    // endpoint that returns an array like
      // [{ id: <providerCommentId>, providers: [...] }, ... ]
      url: '/ProviderComments',
    method: 'GET',
    params: { opts: options },
  },
});

export const queryProviderCommentsContacts = (options, type = API_PROVIDER_COMMENTS_CONTACTS_TABLE) => ({
  type,
  request: {
    // endpoint that returns an array like
      // [{ id: <providerCommentId>, providers: [...] }, ... ]
      url: '/ProviderComments',
    method: 'GET',
    params: { opts: options },
  },
});

export const queryProviderCommentsLocations = (options, type = API_PROVIDER_COMMENTS_LOCATIONS_TABLE) => ({
  type,
  request: {
      url: '/ProviderComments',
    method: 'GET',
    params: { opts: options },
  },
});

export const listProviderComments = (
  providerId,
  contactId,
  locationId,
  clientId
) => {
  const include = [
    {
      association: 'user',
      attributes: ['id', 'first_name', 'last_name'],
    },
    {
      association: 'tags',
      attributes: ['id', 'name', 'namespace_id'],
      include: [
        {
          association: 'namespace',
          attributes: ['id', 'name'],
        },
      ],
    },
    {
      association: 'documents',
      attributes: ['name'],
    },    
    {
      association: 'locations',
      attributes: [
        'id',
        'name',
        'address1',
        'address2',
        'city',
        'state',
        'postal_code',
      ],
      where: {
        ...(!!locationId && { id: locationId }),
      },
      include: [
        {
          association: 'organization',
          attributes: ['id'],
        },
      ],
      required: !!locationId,
    },
  ];

  if (providerId) {
    include.push({
      association: 'providers',
      attributes: [],
      through: {
        attributes: [],
        where: {
          provider_id: providerId,
        },
      },
      required: true,
    });
  }

  if (contactId) {
    include.push({
      association: 'contacts',
      attributes: [],
      through: {
        attributes: [],
        where: {
          contact_id: contactId,
        },
      },
      required: true,
    });
  }

  return queryProviderComments(
    {
      where: {
        client_id: {
          $eq: clientId,
        },
      },
      order: [['comment_date', 'DESC']],
      include,
    },
    API_PROVIDER_COMMENTS_LIST
  );
};


export const getProviderComment = (commentId) => ({
  type: API_PROVIDER_COMMENTS_GET,
  id: commentId,
});

/*
export const getProviderComment = (commentId) => async (dispatch) => {
  dispatch({
    type: API_PROVIDER_COMMENTS_GET,
    id: commentId,
    status: 'pending'
  });

  try {
    // 1. Fetch main ProviderComment with "user" association only
    const mainRes = await axios.get('/ProviderComments', {
      params: {
        opts: {
          where: { id: { $eq: commentId } },
          include: [{
            association: 'user',
            attributes: ['id', 'first_name', 'last_name'],
          }]
        },
      },
    });
    const comment = (mainRes.data && mainRes.data[0]) || null;
    if (!comment) {
      dispatch({
        type: API_PROVIDER_COMMENTS_GET,
        id: commentId,
        status: 'error',
        error: 'Not found'
      });
      return;
    }

    // 2. Fetch all associated entities in parallel
    const [
      providersRes,
      contactsRes,
      documentsRes,
      tagsRes,
      locationsRes
    ] = await Promise.all([
      axios.get(`/ProviderComments/${commentId}/providers`),
      axios.get(`/ProviderComments/${commentId}/contacts`),
      axios.get(`/ProviderComments/${commentId}/documents`),
      axios.get(`/ProviderComments/${commentId}/tags`, {
        params: {
          opts: {
            include: [{
              association: 'namespace',
              attributes: ['id', 'name'],
            }]
          }
        }
      }),
      axios.get(`/ProviderComments/${commentId}/locations`, {
        params: {
          opts: {
            include: [{
              association: 'organization',
              attributes: ['id'],
            }]
          }
        }
      }),
    ]);

    // 3. Populate associations & deduplicate
    comment.providers = uniqById(providersRes.data || []);
    comment.contacts  = uniqById(contactsRes.data  || []);
    comment.documents = uniqById(documentsRes.data || []);
    comment.tags      = uniqById(tagsRes.data      || []);
    comment.locations = uniqById(locationsRes.data || []);

    dispatch({
      type: API_PROVIDER_COMMENTS_GET,
      id: commentId,
      status: 'success',
      payload: comment,
    });
  } catch (error) {
    dispatch({
      type: API_PROVIDER_COMMENTS_GET,
      id: commentId,
      status: 'error',
      error,
    });
  }
};



export const getProviderComment = (commentId) => ({
  type: API_PROVIDER_COMMENTS_GET,
  id: commentId,
  request: {
    url: '/ProviderComments',
    method: 'GET',
    params: {
      opts: {
        where: {
          id: {
            $eq: commentId,
          },
        },
        include: [
          {
            association: 'user',
            attributes: ['id', 'first_name', 'last_name'],
          },
          {
            association: 'providers',
            attributes: ['id', 'first_name', 'last_name', 'middle_name'],
            //separate: true
          },
          {
            association: 'contacts',
            attributes: ['id', 'first_name', 'last_name'],
            //separate: true
          },
          {
            association: 'documents',
            attributes: ['name', 'stored_filename'],
            //separate: true
          },
          {
            association: 'tags',
            attributes: ['id', 'name', 'namespace_id'],
            //separate: true,
            include: [
              {
                association: 'namespace',
                attributes: ['id', 'name'],
              },
            ],
          },
          {
            association: 'locations',
            attributes: ['id', 'name', 'address1', 'address2', 'city', 'state', 'postal_code'],
            //separate: true,
            include: [
              {
                association: 'organization',
                attributes: ['id'],
              },
            ],
            required: false,
          },
        ],
      },
    },
  },
});
*/
export const upsertProviderComment = (data, nextAction) => {
  let options = {
    include: [],
  };

  if (data.providers) {
    options.include.push({ model: 'Providers', as: 'providers' });
  }
  if (data.contacts) {
    options.include.push({ model: 'Contacts', as: 'contacts' });
  }
  if (data.documents) {
    options.include.push({ model: 'Documents', as: 'documents' });
  }
  if (data.locations) {
    options.include.push({ model: 'Locations', as: 'locations' });
  }  
  if (data.tags) {
    options.include.push({ model: 'Tags', as: 'tags' });
  }

  let id = 0;

  if (data.id && data.id > 0) {
    id = data.id;
    options = {
      ...options,
      where: { id },
    };
  }

  return {
    type: API_PROVIDER_COMMENTS_UPSERT,
    id,
    data,
    request: {
      url: '/ProviderComments',
      method: 'PUT',
      params: { opts: options },
      data,
    },
    nextAction: nextAction ?? ((data.provider_id || data.contact_id)
        ? listProviderComments(
            data.provider_id,
            data.contact_id,
            data.location_id,
            data.client_id
          )
        : null),
  };
};

export const listProviderCommentsByTag = (
  tagId 
) => {
  const include = [
    {
      association: 'user',
      attributes: ['id', 'first_name', 'last_name'],
    },
    {
      association: 'tags',
      attributes: ['id', 'name', 'namespace_id'],
      include: [
        {
          association: 'namespace',
          attributes: ['id', 'name'],
        },
      ],
      where: {
        'id': tagId
      },
    },
    {
      association: 'documents',
      attributes: ['name'],
    },    
    {
      association: 'locations',
      attributes: [
        'id',
        'name',
        'address1',
        'address2',
        'city',
        'state',
        'postal_code',
      ],
      include: [
        {
          association: 'organization',
          attributes: ['id'],
        },
      ],
    },
  ];

  return queryProviderComments(
    {
      order: [['comment_date', 'DESC']],
      include,
    },
    API_PROVIDER_COMMENTS_LIST
  );
};

export const deleteProviderComment = (id) => {
  return {
    type: API_PROVIDER_COMMENTS_DELETE,
    id,
    request: {
      url: '/ProviderComments/',
      method: 'DELETE',
      data: [id],
    },
  };
};
